
export default Object.freeze({
  DEFAULT: Symbol('default'),

  SELECT_NODE: Symbol('select_node'),
  DRAG_NODE: Symbol('drag_node'),
  ROTATE_NODE: Symbol('rotate_node'),
  SELECT_KEEP_NODE: Symbol('select_keep_node'),
  MULTIPLE_SELECT_NODE: Symbol('multiple_select_node')
});



// WEBPACK FOOTER //
// ./src/assets/javascripts/nesting/mode.js